import styled from "styled-components";
import fipayFonts from "../../../../theme/index";
import { colors } from "../../../../theme/color";

export const HeroLeftContainer = styled.div`
  width: 605px;
  /* border: 3px solid red; */
  display: flex;
  flex-direction: column;
  justify-content: center;

  @media screen and (max-width: 1440px) and (max-height: 760px) {
    width: 605px;
    height: 100%;
  }

  @media screen and (max-width: 1024px) {
    width: 100%;
    /* height: 100%; */
    margin-top: 40px;
  }

  @media screen and (max-width: 768px) {
    /* width: 605px; */
    width: 100%;
    height: 100%;
  }

  @media screen and (max-width: 430px) {
    /* width: 326px; */
    width: 100%;
    height: 100%;
  }

  @media screen and (max-width: 375px) {
    width: 100%;
    /* width: 326px; */
    height: 100%;
    /* border: 2px solid yellow; */
  }
  @media screen and (max-width: 320px) {
    width: 100%;
    /* width: 326px; */
    height: 365px;
    /* border: 2px solid yellow; */
  }
`;

export const TitleTextHolder = styled.div`
  width: 605px;
  height: 78px;

  @media screen and (max-width: 1440px) {
    width: 605px;
  }

  @media screen and (max-width: 1024px) {
    width: 605px;
    height: 60px;
  }

  @media screen and (max-width: 768px) {
    display: none;
  }

  @media screen and (max-width: 430px) {
    display: none;
  }

  @media screen and (max-width: 375px) {
    display: none;
  }
`;

export const TitleTextHolder2 = styled.div`
  width: 605px;
  height: 128px;
  margin-top: 30px;
  /* border: 2px solid blue; */
  /* display: flex;
  flex-direction: column;
  justify-content: flex-end; */

  @media screen and (max-width: 2560px) {
    display: none;
  }
  @media screen and (max-width: 1440px) {
    display: none;
  }

  @media screen and (max-width: 1024px) {
    display: none;
  }

  @media screen and (max-width: 768px) {
    display: block;
    width: 605px;
    height: 100%;
  }

  @media screen and (max-width: 430px) {
    display: block;
    width: 326px;
    height: 102px;
  }

  @media screen and (max-width: 375px) {
    display: block;
    width: 326px;
    height: 102px;
  }
`;

export const TitleText = styled.div`
  text-align: left;
  font-size: ${fipayFonts.fipayFonts.display1.size};
  font-weight: ${fipayFonts.fipayFonts.fontWeight.bold};
  letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.heading};
  line-height: ${fipayFonts.fipayFonts.lineHeight.display2};
  color: ${colors.NAVYBLUE};

  @media screen and (max-width: 1024px) {
    font-size: ${fipayFonts.fipayFonts.display1.size};
    letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.heading};
    font-weight: ${fipayFonts.fipayFonts.fontWeight.bold};
    line-height: ${fipayFonts.fipayFonts.lineHeight.display2};
    text-align: left;
  }
  @media screen and (max-width: 768px) {
    font-size: ${fipayFonts.fipayFonts.display2.size};
    letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.heading};
    font-weight: ${fipayFonts.fipayFonts.fontWeight.bold};
    line-height: ${fipayFonts.fipayFonts.lineHeight.display2};
    text-align: left;
  }

  @media screen and (max-width: 430px) {
    font-size: ${fipayFonts.fipayFonts.heading2.size};
    letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.heading};
    font-weight: ${fipayFonts.fipayFonts.fontWeight.bold};
    line-height: ${fipayFonts.fipayFonts.lineHeight.heading3};
    /* text-align: left; */
  }

  @media screen and (max-width: 375px) {
    font-size: ${fipayFonts.fipayFonts.heading2.size};
    letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.heading};
    font-weight: ${fipayFonts.fipayFonts.fontWeight.bold};
    line-height: ${fipayFonts.fipayFonts.lineHeight.heading3};
    /* text-align: left; */
  }
  @media screen and (max-width: 320px) {
    font-size: ${fipayFonts.fipayFonts.heading3.size};
    letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.heading};
    font-weight: ${fipayFonts.fipayFonts.fontWeight.bold};
    line-height: ${fipayFonts.fipayFonts.lineHeight.heading2};
    /* text-align: left; */
  }
`;

export const SubtitleTextHolder = styled.div`
  /* width: 550px; */
  width: 100%;
  height: 96px;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  top: 447px;
  left: 100px;
  margin-top: 20px;

  @media screen and (max-width: 1440px) {
    width: 550px;
    height: 96px;
  }

  @media screen and (max-width: 1024px) {
    /* width: 400px; */
    width: 50%;
    height: 100%;
  }

  @media screen and (max-width: 768px) {
    display: block;
    width: 550px;
    height: 72px;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
  }

  @media screen and (max-width: 430px) {
    display: block;
    width: 327px;
    /* width: 45%; */
    height: 120px;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
  }

  @media screen and (max-width: 375px) {
    display: block;
    width: 327px;
    height: 120px;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
  }
  @media screen and (max-width: 320px) {
    display: block;
    width: 300px;
    height: 120px;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
  }
`;

export const SubtitleText = styled.div`
  text-align: left;
  font-size: ${fipayFonts.fipayFonts.body1.size};
  font-weight: ${fipayFonts.fipayFonts.fontWeight.regular};
  letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.body};
  line-height: ${fipayFonts.fipayFonts.lineHeight.body1};
  color: ${colors.DARK_GRAY};

  @media screen and (max-width: 768px) {
    font-size: ${fipayFonts.fipayFonts.body2.size};
    font-weight: ${fipayFonts.fipayFonts.fontWeight.regular};
    letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.body};
    line-height: ${fipayFonts.fipayFonts.lineHeight.body2};
    color: ${colors.DARK_GRAY};
    text-align: left;
  }

  @media screen and (max-width: 430px) {
    font-size: ${fipayFonts.fipayFonts.body2.size};
    font-weight: ${fipayFonts.fipayFonts.fontWeight.regular};
    letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.body};
    line-height: ${fipayFonts.fipayFonts.lineHeight.body2};
    color: ${colors.DARK_GRAY};
    text-align: left;
  }

  @media screen and (max-width: 375px) {
    font-size: ${fipayFonts.fipayFonts.body2.size};
    font-weight: ${fipayFonts.fipayFonts.fontWeight.regular};
    letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.body};
    line-height: ${fipayFonts.fipayFonts.lineHeight.body2};
    color: ${colors.DARK_GRAY};
    text-align: left;
  }
  @media screen and (max-width: 320px) {
    font-size: ${fipayFonts.fipayFonts.body3.size};
    font-weight: ${fipayFonts.fipayFonts.fontWeight.regular};
    letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.body};
    line-height: ${fipayFonts.fipayFonts.lineHeight.body2};
    color: ${colors.DARK_GRAY};
    text-align: left;
  }
`;

export const ButtonContainer = styled.div`
  /* width: 384px; */
  /* height: 52px; */
  /* top: 567px; */
  /* left: 100px; */
  /* padding: 2px 0px 2px 0px; */
  /* border: 3px solid red; */
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin-top: 30px;
  @media screen and (max-width: 430px) {
    /* width: 184px; */
    height: 112px;
    gap: 16px;
    display: flex;
  }

  @media screen and (max-width: 375px) {
    /* width: 184px; */
    height: 112px;
    gap: 16px;
    display: flex;
    flex-direction: column;
  }
`;

// @media screen and (max-width: 1440px) {

//   }

//   @media screen and (max-width: 1024px) {

//   }

//   @media screen and (max-width: 768px) {

//   }

//   @media screen and (max-width: 430px) {

//   }

//   @media screen and (max-width: 375px) {

//   }
